/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgCornerRightUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M15.525 7.256a.68.68 0 0 1-.525.225.68.68 0 0 1-.525-.225L12 4.781v7.2c0 2.1-1.65 3.75-3.75 3.75H3c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h5.25c1.275 0 2.25-.975 2.25-2.25v-7.2L8.025 7.256c-.3.3-.75.3-1.05 0s-.3-.75 0-1.05l3.75-3.75c.075-.075.15-.15.225-.15.15-.075.375-.075.6 0 .075.075.15.075.225.15l3.75 3.75c.3.3.3.75 0 1.05"
    />
    <mask
      id="corner-right-up_svg__a"
      width={14}
      height={14}
      x={2}
      y={2}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="currentColor"
        d="M15.525 7.256a.68.68 0 0 1-.525.225.68.68 0 0 1-.525-.225L12 4.781v7.2c0 2.1-1.65 3.75-3.75 3.75H3c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h5.25c1.275 0 2.25-.975 2.25-2.25v-7.2L8.025 7.256c-.3.3-.75.3-1.05 0s-.3-.75 0-1.05l3.75-3.75c.075-.075.15-.15.225-.15.15-.075.375-.075.6 0 .075.075.15.075.225.15l3.75 3.75c.3.3.3.75 0 1.05"
      />
    </mask>
    <g mask="url(#corner-right-up_svg__a)">
      <path fill="currentColor" d="M0 0h18v18H0z" />
    </g>
  </svg>
)
export default SvgCornerRightUp
